import {DatabaseCode, toDatabaseCode} from "./database-code";

export type TagDefinitionSourceKind = DatabaseCode;

const system: TagDefinitionSourceKind = {
  code: "SYSTEM",
  displayValue: {
    id: "common.entity.tagdefinitionsourcekind.system",
    defaultMessage: "System",
  },
};

const user: TagDefinitionSourceKind = {
  code: "USER",
  displayValue: {
    id: "common.entity.tagdefinitionsourcekind.user",
    defaultMessage: "User",
  },
};

export const tagDefinitionSourceKind = {
  system,
  user,
};

export const tagDefinitionSourceKinds = Object.values(tagDefinitionSourceKind);

export const toTagDefinitionSourceKind = (code: string): TagDefinitionSourceKind =>
  toDatabaseCode(code, tagDefinitionSourceKinds);

export const toTagDefinitionSourceKindSafely = (
  code: string | undefined
): TagDefinitionSourceKind | undefined =>
  code ? toDatabaseCode(code, tagDefinitionSourceKinds) : undefined;
